import { lazy, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  homeLocation,
  aboutLocation,
  contactLocation,
  privacyLocation,
  cookieLocation,
  menuCardLocation,
  dishLocation,
  galleryLocation,
  siteMapLocation,
} from "../constants/routing";
import { Layout } from "../components/layout/Layout";

const Home = lazy(() => import("../pages/home"));
const About = lazy(() => import("../pages/about"));
const Menu = lazy(() => import("../pages/menu"));
const Contact = lazy(() => import("../pages/contact"));
const Privacy = lazy(() => import("../pages/privacy-policy"));
const Cookies = lazy(() => import("../pages/cookies"));
const DishDetail = lazy(() => import("../pages/dish"));
const Gallery = lazy(() => import("../pages/gallery"));
const SiteMap = lazy(() => import("../pages/site-map"));
const Error = lazy(() => import("../pages/not-found"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path={homeLocation} element={<Home />} />
          <Route path={menuCardLocation} element={<Menu />} />
          <Route path={`${menuCardLocation}/:cardId`} element={<Navigate replace to={menuCardLocation} />} />
          <Route path={aboutLocation} element={<About />} />
          <Route path={galleryLocation} element={<Gallery />} />
          <Route path={contactLocation} element={<Contact />} />
          <Route path={privacyLocation} element={<Privacy />} />
          <Route path={cookieLocation} element={<Cookies />} />
          <Route path={siteMapLocation} element={<SiteMap />} />
          <Route path={dishLocation} element={<Navigate replace to={menuCardLocation} />} />
          <Route path={`${dishLocation}/:dishId`} element={<DishDetail />} />
          <Route path="*" element={<Error />} />
        </Route>
        <Route
          path="/admin"
          element={<ExternalRedirect to="https://api.lapiazzagenk.be/login" />}
        />
      </Routes>
    </BrowserRouter>
  );
}
